import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import MergeParsedResume from '@zr/jobseeker-public/apps/jobseeker-parse-resume/components/MergeParsedResume';

import {
  FAILURE,
  SUCCESS,
} from '@zr/utilities/api/mergedResume';

import {
  MERGE_PARSED_RESUME,
} from '../../../screenTypeSchema';

import { applyDataPropTypes } from '../../../applyFlowPropTypes';

import screenTypeTelemetry from '../screenTypeTelemetry';

export function MergeParsedResumeScreenType({
  applyData,
  onScreenTypeFinish,
}) {
  const {
    logFinish,
    logInteraction,
    logView,
  } = screenTypeTelemetry(MERGE_PARSED_RESUME, applyData);

  useEffect(() => {
    logView({
      screen_view_name: 'check_parse',
    });
  }, [logView]);

  const finish = async (parseResult = {}) => {
    logFinish(parseResult);
    await onScreenTypeFinish({
      // this ensures we do not get this screen type/action again
      // we might need to force skip if we waited too long
      completed_merge_parsed_resume: 1,
    });
  };

  const handleMergeFailure = async () => {
    await finish({
      merge_result: FAILURE,
    });
  };

  const handleMergeSuccess = async () => {
    await finish({
      merge_result: SUCCESS,
    });
  };

  const handlePollLimitReached = async () => {
    await finish({
      merge_result: 'slow_parse',
    });
  };

  const handleInitializedParseCorrectionWizard = () => {
    logView({
      screen_view_name: 'show_parse_entry_correction_wizard',
    });
  };

  const handleEntryView = ({
    viewName,
    ...rest
  }) => {
    logView({
      screen_view_name: viewName,
      ...rest,
    });
  };

  const handleEntryInteraction = ({
    interaction,
    ...rest
  }) => {
    logInteraction(interaction, rest);
  };

  return (
    <MergeParsedResume
      companyName={applyData.company_name}
      onEntryInteraction={handleEntryInteraction}
      onEntryView={handleEntryView}
      onMergeFailure={handleMergeFailure}
      onMergeSuccess={handleMergeSuccess}
      onInitializedWizard={handleInitializedParseCorrectionWizard}
      onPollLimitReached={handlePollLimitReached}
      profileMethod={applyData.method}
    />
  );
}

MergeParsedResumeScreenType.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  onScreenTypeFinish: PropTypes.func.isRequired,
};

export default MergeParsedResumeScreenType;
